// LIBRERIE/IMPORTS
import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

// COMPONENTI
import SubHeaderDefault from "../Header/subHeader/SubHeaderDefault";
import useInViewAnimation from "../../hooks/utilityStyle/useInViewAnimation";

const Services: React.FC = () => {

    const { t } = useTranslation();

    const [pageReady, setPageReady] = useState(false);
    useEffect(() => {
        // Questo set time out è divuto al video che falsa lo posizione degli elemnti nel DOM finche non carica
        const timer = setTimeout(() => { 
            setPageReady(true);
        }, 1000);

        return () => clearTimeout(timer);
    }, []);

    const ref1 = useRef<HTMLHeadingElement>(null);
    const allRefs: React.RefObject<HTMLHeadingElement | HTMLParagraphElement | null>[] = [ref1];
    useInViewAnimation({animationElementsRef: allRefs, animationClass: 'fade-in', pageReady: pageReady});

    const servicesList = [
        t('servicesPage.service1'),
        t('servicesPage.service2'),
        t('servicesPage.service3'),
        t('servicesPage.service4'),
        t('servicesPage.service5'),
        t('servicesPage.service6'),
        t('servicesPage.service7'),
        t('servicesPage.service8'),
        t('servicesPage.service9')
    ];

    return (
        <>
            <Helmet>
                <title>{t('servicesPage.pageTitle')}</title>
                <meta name="description" content={t('servicesPage.metaDescription') as string} />
            </Helmet>

            <SubHeaderDefault title={t('servicesPage.subHeaderTitle') as string} isSeo={true} />

            <main id="services-page" className="space-ptb bg-custom">
                <div className="container-fluid w-special">
                    <h2>{t('servicesPage.title')}</h2>
                    <div className="row align-items-center">
                        <div className="col-12 col-lg-7 col-xl-8">
                            <ul>
                                {servicesList.map((service, index) => (
                                    <li key={index} className="mb-2">
                                        {service}
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="col-12 col-lg-5 col-xl-4">
                            <div className="text-center img-wrapper" ref={ref1}>
                                <img src="/assets/images/altrePag/servizi1.jpg" alt={t('servicesPage.imgAlt1') as string} className="img-fluid mb-3" />
                                <img src="/assets/images/altrePag/servizi2.jpg" alt={t('servicesPage.imgAlt2') as string} className="img-fluid" />
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
};

export default Services;